import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { expenseActions } from "../../sagas/expenseSlice";
import * as Yup from 'yup';
import { Button, Card, CardBody, Col, Container, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table } from "reactstrap";
import { FaCubes, FaEdit, FaPlus, FaSearch, FaTrash } from "react-icons/fa";
import Swal from "sweetalert2";

const ExpenseCategorieList = () => {
    const dispatch = useDispatch();
    const categories = useSelector((state) => state.expenses.categories); // Adjust state path as needed
    const [isModalVisible, setIsModalVisible] = useState(false);
    const { t } = useTranslation();
    const [searchTerm, setSearchTerm] = useState('');
    const [initialValues, setInitialValues] = useState({
        id: null,
        code: '',
        libelle: '',
    });

    useEffect(() => {
        dispatch(expenseActions.listCategory({query:""})); // Fetch categories on component mount
    }, [dispatch]);

    useEffect(() => {
        dispatch(expenseActions.listCategory({query:searchTerm})); // Fetch categories on component mount
    }, [searchTerm]);

    useEffect(() => {

    }, [categories]);


    const handleCloseModal = () => {
        setIsModalVisible(false);
        formik.resetForm();
        dispatch(expenseActions.listCategory({query:""})); // Fetch categories on component mount
    };

    const toggleModal = () => {
        setIsModalVisible(!isModalVisible);
    };


    const formik = useFormik({
        initialValues: { ...initialValues },
        enableReinitialize: true,
        validationSchema: Yup.object({
            libelle: Yup.string().required('Libelle is required'),
        }),
        onSubmit: (values) => {
            let payload = {
                data: {
                    id: values.id,
                    code: values.code,
                    libelle: values.libelle,
                },
                onSuccess: () => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Succès',
                        text: 'Catégorie enregistrés avec succès!',
                        confirmButtonText: 'OK',
                    });
                    handleCloseModal();
                }
            }
            if (values?.id) {
                dispatch(expenseActions.updateCategory(payload));
            } else {
                dispatch(expenseActions.createCategory(payload));
            }
        },
    });


    const handleAddCategory = () => {
        formik.handleSubmit();
    }

    const handleDeleteCategory = (id) => {
        dispatch(expenseActions.deleteCategory(id));
    };

    const handleEditCategory = (cat) => {
        setInitialValues({ ...cat });
        toggleModal();
    }

    return (
        <Container fluid>
            <Row className="mb-4" >
                <Col>
                    <Card className="shadow-sm">
                        <CardBody className="d-flex justify-content-between align-items-center">
                            <h4 className="mb-0 d-flex align-items-center">
                                <FaCubes className="text-primary me-2" />
                                {t('expense.category.list')}
                            </h4>
                            <Button
                                color="primary"
                                onClick={() => toggleModal()} // Go back to the previous page
                                className="d-flex align-items-center"
                            >
                                <FaPlus className="me-2" />
                                {t('expense.category.new')}
                            </Button>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Card className="shadow-sm">
                <CardBody>
                    <>
                        <div className="filter-container mb-4">
                            <div className="input-group">
                                <span className="input-group-text bg-light">
                                    <FaSearch />
                                </span>
                                <input
                                    type="text"
                                    placeholder="Rechercher par nom, email, téléphone..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <Table bordered>
                            <thead>
                                <tr>
                                    <th>{t('expense.category.code')}</th>
                                    <th>{t('expense.category.label')}</th>
                                    <th>{t('common.actions')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {categories.length > 0 && categories.map((cat) => (
                                    <tr key={cat.id}>
                                        <td>{cat.code}</td>
                                        <td>{cat.libelle}</td>
                                        <td>
                                            <Button
                                                color="warning"
                                                size="sm"
                                                className="mx-2"
                                                onClick={() => handleEditCategory(cat)}
                                            >
                                                <FaEdit />
                                            </Button>
                                            <Button
                                                color="danger"
                                                size="sm"
                                                onClick={() => handleDeleteCategory(cat.id)}
                                            >
                                                <FaTrash />
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        {categories.length === 0 && (
                            <div className="text-center mt-4">
                                <FaCubes size={50} className="text-muted" />
                                <h5 className="mt-2">{t('expense.category.noCategories')}</h5>
                            </div>
                        )}
                    </>
                </CardBody>
            </Card>
            <Modal isOpen={isModalVisible} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>
                    {t('expense.category.new')}
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={formik.handleSubmit}>

                        <FormGroup>
                            <Label for="libelle">{t('expense.category.label')}</Label>
                            <Input
                                type="text"
                                name="libelle"
                                id="libelle"
                                value={formik.values.libelle}
                                onChange={formik.handleChange}
                                invalid={formik.touched.libelle && Boolean(formik.errors.libelle)}
                            />
                            <FormFeedback>{formik.errors.libelle}</FormFeedback>
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleAddCategory}>
                        {t('common.save')}
                    </Button>{' '}
                    <Button color="secondary" onClick={toggleModal}>
                        {t('common.cancel')}
                    </Button>
                </ModalFooter>
            </Modal>
        </Container>
    );
};

export default ExpenseCategorieList;